<div *ngIf="reportType === 'InDetail'">
  <div class="container-fluid px-4" id="print-section">

    <!-- ================= FIRST PAGE HEADER (Outside Table) ================= -->
    <div class="first-page-header">
      <table style="width: 100%; border-collapse: collapse; border: 1px solid black; margin-bottom: 0;">
        <thead>
          <!-- Main Header -->
          <tr style="font-size: 18px; font-weight: bold;">
            <th colspan="2" style="border:1px solid black; text-align:center; padding:6px; font-size: 18px; background-color: #f1f1f1;">
              हिंदुस्तान प्रकाशन संस्था 
            </th>
            <th colspan="3" style="border:1px solid black; text-align:center; padding:6px; font-weight:bold; font-size: 18px; background-color: #f1f1f1;">
              Book Credit Note Report
            </th>
            <th colspan="2" style="border:1px solid black; text-align:right; padding:6px; font-size: 18px; background-color: #f1f1f1;">
              दिनांक {{ currentDate | date: 'dd-MM-yyyy' }}
            </th>
          </tr>

          <!-- Sub Header -->
          <tr style="font-size: 18px; font-weight: bold;">
            <th colspan="2" style="border:1px solid black; padding:6px; text-align:center; font-size: 16px; font-weight: bold; background-color: #f1f1f1;">
              विवेक पुस्तक प्रकाशन
            </th>
            <th colspan="3" style="border:1px solid black; padding:6px; font-size: 16px; font-weight: bold; background-color: #f1f1f1;text-align:center;">InDetail</th>
            <th colspan="2" style="border:1px solid black; padding:6px; text-align:right; font-size: 16px; font-weight: bold; background-color: #f1f1f1;">
              Date : From {{ startDate | date:'dd-MM-yyyy' }} To {{ endDate | date:'dd-MM-yyyy' }}
            </th>
          </tr>
        </thead>
      </table>
    </div>

    <!-- ================= MAIN DATA TABLE ================= -->
    <table class="table table-bordered table-sm w-100" style="border-collapse: collapse; border:1px solid black; margin-top: 0;">

      <!-- ================= COLUMN HEADERS (Repeat on Every Page) ================= -->
      <thead class="text-center align-middle">
        <tr style="font-weight:bold;">
          <th style="border:1px solid black; padding:6px; background-color: #f1f1f1;">Credit Not date</th>
          <th style="border:1px solid black; padding:6px; background-color: #f1f1f1;">Credit Not No.</th>
          <th style="border:1px solid black; padding:6px; text-align:left; background-color: #f1f1f1;">Book Seller Name</th>
          <th style="border:1px solid black; padding:6px; background-color: #f1f1f1;">Invoice No.</th>
          <th style="border:1px solid black; padding:6px; background-color: #f1f1f1;">Invoice Date</th>
          <th style="border:1px solid black; padding:6px; text-align:right; background-color: #f1f1f1;width:10%;">Invoice Amount</th>
          <th style="border:1px solid black; padding:6px; text-align:right; background-color: #f1f1f1;width:10%;">Receipt Amount</th>
        </tr>
      </thead>

      <!-- ================= BODY ================= -->
      <tbody>
        <ng-container *ngFor="let office of groupedData">
          
          <!-- Office Representative Name Header -->
          <tr style="font-weight: bold; text-align:center">
            <td colspan="7" style="border:1px solid black; padding:6px; text-align:center;">
              Office Representative Name - {{ office.office_rep_name }}
            </td>
          </tr>

          <!-- Loop through Representatives under this Office -->
          <ng-container *ngFor="let rep of office.representatives">
            
            <!-- Representative Name Header -->
            <tr>
              <td colspan="7" style="border:1px solid black; padding:6px; font-weight: bold;">
                Representative Name- {{ rep.rep_name }}
              </td>
            </tr>

            <!-- Data Rows for this Representative -->
            <tr *ngFor="let data of rep.records">
              <td style="border:1px solid black; padding:6px;">{{ data.crdtnote_date }}</td>
              <td style="border:1px solid black; padding:6px;">{{ data.crdtnote_no }}</td>
              <td style="border:1px solid black; padding:6px; text-align:left;">{{ data.book_seller_name }}</td>
              <td style="border:1px solid black; padding:6px;">{{ data.bill_no }}</td>
              <td style="border:1px solid black; padding:6px;">{{ data.billdate }}</td>
              <td style="border:1px solid black; padding:6px; text-align:right;">{{ data.bill_amount }}</td>
              <td style="border:1px solid black; padding:6px; text-align:right;">{{ data.crdtnote_total }}</td>
            </tr>

            <!-- Representative Total Row -->
            <tr style="font-weight: bold;">
              <td colspan="5" style="border:1px solid black; text-align:right; padding:6px;">
                Representative Total:
              </td>
              <td style="border:1px solid black; text-align:right; padding:6px;">
                {{ rep.rep_bill_total }}
              </td>
              <td style="border:1px solid black; text-align:right; padding:6px;">
                {{ rep.rep_credit_total }}
              </td>
            </tr>

          </ng-container>

          <!-- Office Representative Total Row -->
          <tr style="background-color: #f4b084; font-weight: bold;">
            <td colspan="5" style="border:1px solid black; text-align:right; padding:6px;">
              Office Representative Total: {{ office.office_rep_name }}
            </td>
            <td style="border:1px solid black; text-align:right; padding:6px;">
              {{ office.office_bill_total }}
            </td>
            <td style="border:1px solid black; text-align:right; padding:6px;">
              {{ office.office_credit_total }}
            </td>
          </tr>

        </ng-container>
      </tbody>

      <!-- ================= FOOTER ================= -->
     
        <tr style="font-weight:bold; background-color: #c8753f;">
          <td colspan="5" style="border:1px solid black; text-align:right; padding:6px;">
            Grand Total:
          </td>
          <td style="border:1px solid black; text-align:right; padding:6px;">
            {{ TotalBillAmt }}
          </td>
          <td style="border:1px solid black; text-align:right; padding:6px;">
            {{ TotalCreditNoteAmt }}
          </td>
        </tr>
    

    </table>
  </div>

  <!-- Buttons -->
  <div class="noPrint d-flex justify-content-end gap-3 px-4 mb-4 mt-3">
    <button class="btn btn-primary" (click)="exportExcel('BookCreditNote_InDetail_Report')">Export</button>
    <button class="btn btn-primary" (click)="printPage4()">Print</button>
    <button class="btn btn-secondary" mat-dialog-close>Close</button>
  </div>
</div>